import axios from "axios";
import React, { useEffect } from "react";
import {
  FaFaceAngry,
  FaFaceFrown,
  FaFaceGrinWide,
  FaFaceMeh,
  FaFaceSmile,
  FaRegFaceAngry,
  FaRegFaceFrown,
  FaRegFaceGrinWide,
  FaRegFaceMeh,
  FaRegFaceSmile,
} from "react-icons/fa6";

const Form3 = ({ formData, setFormData, setCurrentStep, link }) => {
  const handleSubmit = (e) => {
    setCurrentStep(4);
    e.preventDefault();
    setTimeout(() => {
      window.scrollTo(0, window.innerHeight * 4);
      if (link) {
        axios.post(
          `https://feedback-git-main-feedback-services-projects.vercel.app/feedback?phone=${formData.phone}`,
          formData
        );
      } else axios.post("https://saboo-nexa.onrender.com/feedback", formData);
    }, 500);
  };

  useEffect(() => {
    if (
      formData.advisorsUnderstandingWorkingRequirement !== "" &&
      formData.advisorsListenAbility !== ""
    ) {
      setCurrentStep(4);
      setTimeout(() => {
        window.scrollTo(0, window.innerHeight * 4);
        if (link) {
          axios.post(
            `https://feedback-git-main-feedback-services-projects.vercel.app/feedback?phone=${formData.phone}`,
            formData
          );
        } else axios.post("https://saboo-nexa.onrender.com/feedback", formData);
      }, 500);
    }
  }, [
    formData.advisorsUnderstandingWorkingRequirement,
    formData.advisorsListenAbility,
  ]); // Removed handleSubmit from dependencies

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        className="flex items-center justify-center h-screen px-2"
      >
        <div className="w-full max-w-xl md:max-w-3xl ">
          <p className="mb-2 text-lg font-bold text-center lg:mb-4 md:text-left">
            Service advisors understanding of work required
          </p>
          <div className="flex justify-center mt-4 mb-16 gap-x-2 lg:justify-start">
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white${formData.advisorsUnderstandingWorkingRequirement === "Excellent"
                  ? "  border-green-600 "
                  : " border-gray-200   "
                } `}
            >
              <label
                htmlFor="advisorsUnderstandingWorkingRequirementExcellent"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-green-600">
                  {formData.advisorsUnderstandingWorkingRequirement !==
                    "Excellent" ? (
                    <FaRegFaceGrinWide className="" />
                  ) : (
                    <FaFaceGrinWide />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Excellent
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="advisorsUnderstandingWorkingRequirementExcellent"
                    className="w-1 h-1 max-w-2xl "
                    name="advisorsUnderstandingWorkingRequirement"
                    value="Excellent"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        advisorsUnderstandingWorkingRequirement: e.target.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>{" "}
            <div
              className={`flex gap-5 mb-2 bg-white  rounded-lg border-2 md:w-1/5  ${formData.advisorsUnderstandingWorkingRequirement === "Very Good"
                  ? " border-[#89C442]"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="advisorsUnderstandingWorkingRequirementVeryGood"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-[#89C442] text-xl">
                  {formData.advisorsUnderstandingWorkingRequirement !==
                    "Very Good" ? (
                    <FaRegFaceSmile className="" />
                  ) : (
                    <FaFaceSmile className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Very Good
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="advisorsUnderstandingWorkingRequirementVeryGood"
                    className="w-1 h-1 max-w-2xl "
                    name="advisorsUnderstandingWorkingRequirement"
                    value="Very Good"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        advisorsUnderstandingWorkingRequirement: e.target.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 bg-white  rounded-lg border-2 md:w-1/5  ${formData.advisorsUnderstandingWorkingRequirement === "Good"
                  ? " border-yellow-500"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="advisorsUnderstandingWorkingRequirementGood"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-yellow-500">
                  {formData.advisorsUnderstandingWorkingRequirement !==
                    "Good" ? (
                    <FaRegFaceMeh />
                  ) : (
                    <FaFaceMeh />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Good
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="advisorsUnderstandingWorkingRequirementGood"
                    className="w-1 h-1 max-w-2xl "
                    name="advisorsUnderstandingWorkingRequirement"
                    value="Good"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        advisorsUnderstandingWorkingRequirement: e.target.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 bg-white  rounded-lg border-2 md:w-1/5  ${formData.advisorsUnderstandingWorkingRequirement === "Average"
                  ? " border-orange-600"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="advisorsUnderstandingWorkingRequirementAverage"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-orange-600">
                  {formData.advisorsUnderstandingWorkingRequirement !==
                    "Average" ? (
                    <FaRegFaceFrown className="" />
                  ) : (
                    <FaFaceFrown className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Average
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="advisorsUnderstandingWorkingRequirementAverage"
                    className="w-1 h-1 max-w-2xl "
                    name="advisorsUnderstandingWorkingRequirement"
                    value="Average"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        advisorsUnderstandingWorkingRequirement: e.target.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 bg-white  rounded-lg border-2 md:w-1/5  ${formData.advisorsUnderstandingWorkingRequirement === "Poor"
                  ? " border-red-600"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="advisorsUnderstandingWorkingRequirementPoor"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-red-600">
                  {formData.advisorsUnderstandingWorkingRequirement !==
                    "Poor" ? (
                    <FaRegFaceAngry className="" />
                  ) : (
                    <FaFaceAngry className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Poor
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="advisorsUnderstandingWorkingRequirementPoor"
                    className="w-1 h-1 max-w-2xl "
                    name="advisorsUnderstandingWorkingRequirement"
                    value="Poor"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        advisorsUnderstandingWorkingRequirement: e.target.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>
          </div>

          <p className="mt-6 mb-2 text-lg font-bold text-center md:mt-12 lg:mt-14 lg:mb-4 md:text-left ">
            Service advisors ability to listen
          </p>

          <div className="flex justify-center mt-4 mb-16 gap-x-2 lg:justify-start">
            <div
              className={`flex gap-5 mb-2 bg-white  rounded-lg border-2 md:w-1/5  ${formData.advisorsListenAbility === "Excellent"
                  ? "  border-green-600 "
                  : " border-gray-200   "
                } `}
            >
              <label
                htmlFor="advisorsListenAbilityExcellent"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-green-600">
                  {formData.advisorsListenAbility !== "Excellent" ? (
                    <FaRegFaceGrinWide className="" />
                  ) : (
                    <FaFaceGrinWide className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Excellent
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="advisorsListenAbilityExcellent"
                    className="w-1 h-1 max-w-2xl "
                    name="advisorsListenAbility"
                    value="Excellent"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        advisorsListenAbility: e.target.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>{" "}
            <div
              className={`flex gap-5 mb-2 bg-white  rounded-lg border-2 md:w-1/5  ${formData.advisorsListenAbility === "Very Good"
                  ? " border-[#89C442]"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="advisorsListenAbilityVeryGood"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-[#89C442]">
                  {formData.advisorsListenAbility !== "Very Good" ? (
                    <FaRegFaceSmile className="" />
                  ) : (
                    <FaFaceSmile className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Very Good
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="advisorsListenAbilityVeryGood"
                    className="w-1 h-1 max-w-2xl "
                    name="advisorsListenAbility"
                    value="Very Good"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        advisorsListenAbility: e.target.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 bg-white  rounded-lg border-2 md:w-1/5  ${formData.advisorsListenAbility === "Good"
                  ? " border-yellow-500"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="advisorsListenAbilityGood"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-yellow-500">
                  {formData.advisorsListenAbility !== "Good" ? (
                    <FaRegFaceMeh className="" />
                  ) : (
                    <FaFaceMeh className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Good
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="advisorsListenAbilityGood"
                    className="w-1 h-1 max-w-2xl "
                    name="advisorsListenAbility"
                    value="Good"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        advisorsListenAbility: e.target.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 bg-white  rounded-lg border-2 md:w-1/5  ${formData.advisorsListenAbility === "Average"
                  ? " border-orange-600"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="advisorsListenAbilityAverage"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-orange-600">
                  {formData.advisorsListenAbility !== "Average" ? (
                    <FaRegFaceFrown className="" />
                  ) : (
                    <FaFaceFrown className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Average
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="advisorsListenAbilityAverage"
                    className="w-1 h-1 max-w-2xl "
                    name="advisorsListenAbility"
                    value="Average"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        advisorsListenAbility: e.target.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 bg-white  rounded-lg border-2 md:w-1/5  ${formData.advisorsListenAbility === "Poor"
                  ? " border-red-600"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="advisorsListenAbilityPoor"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-red-600">
                  {formData.advisorsListenAbility !== "Poor" ? (
                    <FaRegFaceAngry className="" />
                  ) : (
                    <FaFaceAngry className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Poor
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="advisorsListenAbilityPoor"
                    className="w-1 h-1 max-w-2xl "
                    name="advisorsListenAbility"
                    value="Poor"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        advisorsListenAbility: e.target.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>
          </div>

          <div className="flex items-center justify-center gap-5 mt-10 lg:justify-end">
            {/* <p className="italic ">
              Press <span className="font-bold uppercase">Enter</span>
            </p> */}
            <button
              type="submit"
              className="px-6 py-3 font-bold text-white uppercase bg-gray-900 rounded-md whitespace-nowrap"
            >
              Next
            </button>
          </div>
        </div>{" "}
      </form>
    </div>
  );
};

export default Form3;
